import { render, staticRenderFns } from "./ContentBoard.vue?vue&type=template&id=72bae5c0&scoped=true"
import script from "./ContentBoard.vue?vue&type=script&lang=js"
export * from "./ContentBoard.vue?vue&type=script&lang=js"
import style0 from "./ContentBoard.vue?vue&type=style&index=0&id=72bae5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bae5c0",
  null
  
)

export default component.exports